import React, { useContext } from 'react';
import { Button } from '../../../../../ui';
import { Copy, Flexer } from '../../../../dashboard/elements/LayoutElements';
import { AssistantContext } from '../../AssistantContext';
import { useAssitantToolCallResult } from '../../AssistantHooks';
import { AssitantToolSupport } from '../../AssistantToolSupport';
import { ToolCallPart } from '../../ChatTypes';

const SwitchModeToolCallView = React.memo(({ toolCallId, args }: ToolCallPart) => {

    const { mode } = args;
    const result = useAssitantToolCallResult(toolCallId) as any;
    const { addToolResult, append, submit } = useContext(AssistantContext);

    const onResult = (allow: boolean) => {
        const shouldSubmit = addToolResult(toolCallId, {
            response: allow ? 'allow' : 'deny',
            mode,
            message: allow ? `Now in ${mode} mode` : `Switch to ${mode} mode denied`,
        });
        if (shouldSubmit) {
            append({
                role: 'user',
                content: [{
                    type: 'text',
                    text: `
                    The user has allowed you to switch to ${mode} mode.  
                    You now have new tools available to you.
                    Re-evaluate the users request prior to switching mode and continue using your new tool set.
                    `
                }],
            });
            submit();
        }
    };

    return <Flexer padding=".5" >
        {result && <>
            <Copy flush>
                {result?.message}
            </Copy>
        </>}
        {!result && <>
            <Copy flush>
                Ludi would like to switch to <b>{mode} mode</b>.
            </Copy>
            <Flexer height=".5" />
            <Flexer flex="row" gap=".5" align="center">
                <Button onAction={() => onResult(true)}>
                    Allow
                </Button>
                <Button onAction={() => onResult(false)}>
                    Deny
                </Button>
            </Flexer>
            <Flexer height=".5" />
            <Copy size=".75" flush>
                Switching mode allows Ludi to use mode specific tools, but starts a new context.
            </Copy>
        </>}
    </Flexer>;
});

export const SwitchModeSupport = AssitantToolSupport({
    toolName: 'switchMode',
    ui: SwitchModeToolCallView,
});
